import { gql } from '@apollo/client'

export const SAVE_OBSTACLE = gql`
  mutation createOrUpdateObstacle($input: ObstacleInput!) {
    createOrUpdateObstacle(input: $input) {
      id
    }
  }
`
export const SAVE_OBSTACLE_BY_GUID = gql`
  mutation saveObstacleByGuid($input: ObstacleInput!) {
    updateObstacleByGuid(input: $input) {
      id
    }
  }
`
export const DELETE_OBSTACLE_BY_GUID = gql`
  mutation deleteObstacleByGuid($id: String!) {
    deleteObstacleByGuid(id: $id)
  }
`
